/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb4_Point_2_LabelInputs */

const en_visa_eb4_point_2_label = /** @type {(inputs: Visa_Eb4_Point_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Careful Issue Spotting`)
};

const pt_visa_eb4_point_2_label = /** @type {(inputs: Visa_Eb4_Point_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificação Cuidadosa de Questões`)
};

const es_visa_eb4_point_2_label = /** @type {(inputs: Visa_Eb4_Point_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificación Cuidadosa de Cuestiones`)
};

/**
* | output |
* | --- |
* | "Careful Issue Spotting" |
*
* @param {Visa_Eb4_Point_2_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb4_point_2_label = /** @type {((inputs?: Visa_Eb4_Point_2_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb4_Point_2_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb4_point_2_label(inputs)
	if (locale === "es") return es_visa_eb4_point_2_label(inputs)
	return en_visa_eb4_point_2_label(inputs)
});